import { useQuery, useQueryClient } from "react-query";
import { CommonMainWrap } from "../../styles/common";
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { styled } from "styled-components";
import theme from "../../styles/theme";


import StatusCards from "./StatusCards";
import Schedule from "./detail/Schedule";
import CodingStatus from "./CodingStatus";
import Notice from "./Notice";
import NowNext from "./NowNext";
import Project from "./Project";
import SetSchedules from "./SetSchedules";
import moment from "moment";
import Moment from "react-moment";
import { useEffect, useState } from "react";
import { useGetDataTime } from "../../interfaces/common";
import { useGetProjectSchedule } from "../../interfaces/dashboard";

const MainWrap = styled.div`
    width: 100%;
    height: 100vh;
    overflow: hidden;
`;

const HeaderWrap = styled.div`
    padding: 12px 2%;
    height: 3rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
`;

const ScrollWrap = styled.div`
    overflow: auto;
    height: calc(100vh - 3rem);
    padding: 0 2% 1rem 2%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const Card = styled.div`
    background: ${theme.color.white[100]};
    height: 100%;
    border-radius: 12px;
`;



const Dashboard = () => {

    const queryClient = useQueryClient();
    // const {data} = useGetDataTime();
    const {data: menuStatus} = useQuery(['MENU_STATUS']);
    const {dataUpdatedAt} = useGetProjectSchedule();
    const handleMenuIconClick = () => {
        queryClient.setQueryData('MENU_STATUS',!menuStatus);
    }

    return (
        <MainWrap>
            <HeaderWrap>
                <div>
                    <MenuOpenIcon onClick={handleMenuIconClick} style={{cursor:'pointer',marginBottom:2}}/> &nbsp;
                    <span>Dashboard</span>
                </div>
                <span>{dataUpdatedAt && moment(dataUpdatedAt).format('yyyy-MM-DD HH:mm:ss')}</span>
            </HeaderWrap>
            <ScrollWrap>
                <div style={{display: 'grid', gridTemplateColumns:'30% auto', gap:'1rem', height: '10%', maxHeight:'10%'}}>
                    <NowNext />
                    <StatusCards />
                </div>
                <div style={{flexGrow:1}}>
                    <Project />
                </div>
                <div style={{height:'8rem',maxHeight:'8rem'}}>
                    <Notice />
                </div>
            </ScrollWrap>
        </MainWrap>
    )
}

export default Dashboard;